import { Button, cn } from '@shared/cove-ui';
import { openChat } from '@shared/chat-js';
import { HTMLAttributes } from 'react';

export const getDisplayNumber = (phone: number | string) => {
  const phoneNumber = String(phone);
  const first = phoneNumber.slice(1, 4);
  const second = phoneNumber.slice(4, 7);
  const third = phoneNumber.slice(7, 11);

  return `${first}.${second}.${third}`;
};

export const chatConfig = {
  general: {
    number: 18552683669,
  },
  sales: {
    number: 18558440685,
  },
};

export default function LearnMore({
  title = 'Want to learn more?',
  text = 'Chat with one of our friendly customer support agents. They’re available 24/7 to answer your questions.',
  buttonText = 'Chat With Us',
  callText = 'Call Us',
  variant = 'general',
  className,
  ...props
}: {
  title?: string;
  text?: string;
  buttonText?: string;
  callText?: string;
  variant?: 'general' | 'sales';
} & HTMLAttributes<HTMLDivElement>) {
  const config = chatConfig[variant];
  const phoneNumber = config.number;

  return (
    <section
      data-slot="learn-more"
      className={cn(
        'mb-cove-150 px-cove-25 sm:px-cove-50 text-cove-navy-blue mx-auto w-full max-w-[720px] md:p-0',
        className
      )}
      {...props}
    >
      <h4 className="mb-cove-15 text-cove-navy-blue text-left text-2xl font-bold sm:text-center sm:text-[32px] sm:font-bold sm:leading-[39px]">
        {title}
      </h4>
      <p className="mb-cove-35 mx-auto text-left sm:text-center">{text}</p>
      <div className="gap-cove-35 mx-auto flex max-w-[540px] flex-col items-center justify-center text-center sm:flex-row">
        <Button
          href={`tel:${phoneNumber}`}
          variant="text"
          size="large"
          className="max-w-button hidden w-full text-base sm:flex sm:text-lg"
        >
          <span className="block sm:hidden">{callText}</span>
          <span className="hidden sm:block">
            Call {getDisplayNumber(phoneNumber)}
          </span>
        </Button>
        <Button
          href={`tel:${phoneNumber}`}
          variant="outlined"
          size="large"
          className="text-base sm:hidden sm:text-lg"
        >
          <span className="block sm:hidden">{callText}</span>
          <span className="hidden sm:block">
            Call {getDisplayNumber(phoneNumber)}
          </span>
        </Button>
        <Button
          size="large"
          variant="outlined"
          className="rounded-full"
          onClick={() => openChat(variant)}
        >
          {buttonText}
        </Button>
      </div>
    </section>
  );
}
